import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import { MDF_AND_EXCL_MODAL_SECTIONS } from '../../constants';
import { mdfAndExclModalStore } from '../../store';
import Crumbs, { CrumbsType, ICrumb } from '~/view/components/Controls/Crumbs';

const ModifierAndExclusionModalHeaderSections: FC = observer((): JSX.Element | null => {
  const { isMulti, isOnlyModifiers, section } = mdfAndExclModalStore;

  const headerCrumbs = useMemo((): ICrumb[] => {
    return [
      { value: MDF_AND_EXCL_MODAL_SECTIONS.MODIFIERS, label: 'modifiers' },
      { value: MDF_AND_EXCL_MODAL_SECTIONS.EXCLUSIONS, label: 'Exclusions' },
    ];
  }, []);

  if (isOnlyModifiers && isMulti) return null;

  return (
    <Crumbs
      type={CrumbsType.TAB}
      crumbs={headerCrumbs}
      activeCrumb={section}
      onClick={mdfAndExclModalStore.changeSection}
      translateLabel
      withPartition
    />
  );
});

export default ModifierAndExclusionModalHeaderSections;
